import { combineReducers } from "redux";
import { sidebarReducer } from "./Sidebar/sidebarReducer";
import { authenticationReducer } from "./Authentication/authenticationReducer";
import { invoicesReducer } from "./Invoices/invoicesReducer";
import { clientsReducer } from "./Clients/clientsReducer";
import { shareholdersReducer } from "./Shareholders/shareholdersReducer";
import { transactionReducers } from "./Transactions/transactionReducers";
import { spendReducer } from "./Spends/spendReducer";
import { dashboardReducer } from "./Dashboard/dashboardReducer";
import { designationReducer } from "./Designation/designationReducer";
import { userReducer } from "./Users/userReducer";
import { departmentReducer } from "./Department/departmentReducer";
import { attendanceReducer } from "./Attendance/attendanceReducer";
import { taskReducer } from "./Task/taskReducer";
import { timesheetReducer } from "./TimeSheet/timesheetReducer";
import { deleteReducer } from "./Delete/deleteReducer";
import { projectReducer } from "./Project/projectReducer";
import { documentReducer } from "./Document/documentReducer";
import { leaveReducer } from "./Leave/leaveReducer";
import { appreciationReducer } from "./Appreciation/appreciationReducer";
import { awardReducer } from "./Award/awardReducer";
import { bankdetailsReducer } from "./Bankdetails/bankdetailsReducer";
import { noticeReducer } from "./Notice/noticeReducer";
import { ticketReducer } from "./Ticket/ticketReducer";
import { salaryReducer } from "./Salary/salaryReducer";
import { holidayReducer } from "./Holiday/holidayReducer";
import { specialdayReducer } from "./Specialday/specialdayReducer";
import { waterJugReducer } from "./WaterJug/waterJugReducer";
import { reminderReducer } from "./Reminder/reminderReducer";

export const rootReducer = combineReducers({
  sidebarReducer,
  authenticationReducer,
  dashboardReducer,
  invoicesReducer,
  clientsReducer,
  shareholdersReducer,
  transactionReducers,
  spendReducer,
  designationReducer,
  userReducer,
  departmentReducer,
  attendanceReducer,
  taskReducer,
  timesheetReducer,
  deleteReducer,
  projectReducer,
  documentReducer,
  leaveReducer,
  appreciationReducer,
  awardReducer,
  bankdetailsReducer,
  noticeReducer,
  ticketReducer,
  salaryReducer,
  holidayReducer,
  specialdayReducer,
  waterJugReducer,
  reminderReducer
});
